<template>
  <div>
    <div class="parent">
      <div class="content">
        <div class="time" v-text="obj.created_at">

        </div>

        <div class="contents" v-text="obj.message">

        </div>
      </div>
    </div>

    <div class="icon">

    </div>

  </div>


</template>

<script type="text/ecmascript-6">
  export default{
    props: {
      obj: {
        type: Object
      }
    }
  };

</script>

<style scoped lang="scss" type="text/scss" rel="stylesheet/scss">
  @import '../assets/scss/base.scss';
  .parent{
    margin-top: px2rem(30);
    width: px2rem(655);
    border-radius: 6px;
    background-color: rgba(255,246,216,1);
    .content{
      padding: px2rem(32);
      font-size: 0px;
    }
    .time{
      float: left;
      width: px2rem(150);
      font-size: px2rem(28);
    }
    .contents{
      padding-left: px2rem(29);
      width: px2rem(396);
      float: right;
      line-height: 1.5;
      font-size: px2rem(28);
    }
  }
  .content:after{ display: block; clear:both; content: '';}


</style>



// WEBPACK FOOTER //
// VMessage.vue?7dc6ca1b